import React from "react";

const formatDate = (value) => {
    if (!value) return "";
    return new Date(value).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });
};

export default function ModulePersonalNotesList({ notes = [], onOpen }) {
    if (!notes.length) {
        return <div className="mpn-state">Aucune note ne correspond aux criteres.</div>;
    }

    return (
        <div className="mpn-list">
            {notes.map((note) => (
                <article key={note.id} className="mpn-note">
                    <button type="button" className="mpn-note-main" onClick={() => onOpen?.(note)}>
                        <div className="mpn-note-head">
                            <div>
                                <strong>{note.noteTitle || "Note personnelle"}</strong>
                                <span>{note.contentTitle || "Contenu"}</span>
                            </div>
                            <em>{note.noteContextLabel || note.noteContextType}</em>
                        </div>
                        <p>{note.previewText || note.noteText}</p>
                        <div className="mpn-note-meta">
                            <span>{note.sectionTitle || "Sans section"}</span>
                            <span>{note.contentType || note.noteContextType}</span>
                            <span>{formatDate(note.createdAt)}</span>
                        </div>
                    </button>
                </article>
            ))}
        </div>
    );
}
